import { Injectable, state } from '@angular/core';
import { UserModel, SysconfigModel } from '../models/user.model';
import { StorageService } from '../providers/storage.service';
import { Title } from '@angular/platform-browser';
import { NavController } from 'ionic-angular';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AppConfig {

    constructor(private storage: StorageService, private titleService: Title) { }

    public static loading: boolean = false;
    public static connected: boolean = false;
    public static User: UserModel;
    public static Sysconfig: SysconfigModel;

    /**
     *六合彩年份
     * @static
     * @type {number}
     * @memberof AppComponent
     */
    public static lhcYear: number = 0;
    /**
     *下标对应生肖数组
     * @memberof AppComponent
     */
    public static numZodiacLastArr = {};
    /**
     *下标对应生肖数组
     * @memberof AppComponent
     */
    public static numZodiacArr = {};
    /**
     *当前年份起始期号
     * @memberof AppComponent
     */
    public static beginIssue: number = 0;
    /**
     *后台彩种更新时间戳
     * @static
     * @type {number}
     * @memberof AppComponent
     */
    public static timing: number = 0;

    /**
    * 播放声音
    * @static
    * @memberof AppConfig
    */
    public static canPlayWinning: boolean = false;
    public static winPlayVoice: boolean = false;
    // 提示消息
    public static warninfo = [];
    //未读消息数量
    public static unreadCount = 0;
    //未查到记录提示
    public static emptyMessage = '暂未查到任何记录';
    //日期格式化
    public static cn = {
        firstDayOfWeek: 1,
        dayNames: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
        dayNamesShort: ['日', '一', '二', '三', '四', '五', '六'],
        dayNamesMin: ['日', '一', '二', '三', '四', '五', '六'],
        monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        monthNamesShort: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
    };
    //默认pagesize
    public static pageSize = 10;
    //默认pageLinkSize
    public static pageLinkSize = 3;
    //时间截止，更新issue，追号使用
    public static currIssue = null;
    // 投注页记时
    public setIntervalid;
    // MP3 提示声音
    mp3 = new Audio("assets/mp3/guoan.mp3");

    /**
         * 轮询定时器
         * @static
         * @type {*}
         * @memberof AppConfig
         */
    public static getCacheTimer: any;

    /**
     *
     * signlar重连判定
     * @static
     * @memberof AppConfig
     */
    public static connetionFlag: boolean = true;


    /**
     * signalr连接对象
     * @static
     * @type {SignalR.Hub.Connection}
     * @memberof AppConfig
     */
    public static connection: SignalR.Hub.Connection;

    /**
     * 获取当前登录用户信息
     * Evan 2018-05-25 
     * @returns 当前登录用户信息
     * @memberof AppConfig
     */
    public getCurrentUser() {
        AppConfig.User = this.storage.read<UserModel>('User');
        return AppConfig.User;
    };

    /**
     * 获取系统基本配置信息
     * Evan 2018-05-25 
     * @returns 系统基本配置信息
     * @memberof AppConfig
     */
    public getSysConfig() {
        AppConfig.Sysconfig = this.storage.read<SysconfigModel>('sysconfig');
        return AppConfig.Sysconfig;
    }

    /**
     * 获取全部彩种分类
     * Evan 2018-05-25 
     * @returns 获取的全部彩种分类
     * @memberof AppConfig
     */
    public getLotterys() {
        var data = this.storage.read<Object[]>('lotterys');
        if (data == null) {
            return null;
        }
        var formatData = {};
        var lotterys = [];
        for (var i = 0; i < data.length; i++) {
            var item = formatData[data[i]['LotteryType']];
            if (!item) {
                item = formatData[data[i]['LotteryType']] = {
                    code: data[i]['LotteryType'],
                    name: data[i]['LotteryTypeName'],
                    plays: []
                }
                lotterys.push(item);
            }
            item['plays'].push(data[i]);
        }
        return lotterys;
    }
    
    public static OldThird = ",ag,bg,bs,cr,ebet,im,im2,jm,kx,ky,ob,os,oubo,pg,pmreal,sb,ug,vr,yb,yblive,yg,yx,";

    thirdGameListSubject = new BehaviorSubject<any[]>([]);
    
    public getIndexLotterys() {
        var data = this.storage.read<Object[]>('lotterys');
        if (data == null) {
            return null;
        }
        var formatData = {};
        var lotterys = [];
        for (var i = 0; i < data.length; i++) {
            var item = formatData[data[i]['LotteryTypeCodeDisplay']];
            if (!item) {
                item = formatData[data[i]['LotteryTypeCodeDisplay']] = {
                    type: data[i]['LotteryTypeCodeDisplay'],
                    typeName: data[i]['LotteryTypeNameDisplay'],
                    plays: []
                }
                lotterys.push(item);
            }
            item['plays'].push(data[i]);
        }
        return lotterys;
    }

    /**
     * 获取全部彩种
     * Evan 2018-05-25 
     * @returns 获取的全部彩种
     * @memberof AppConfig
     */
    public getLotteryAll() {
        var data = this.storage.read<any>('lotterys');
        return data;
    }

    /**
     * 设置用户API访问地址
     */
    public static GetProdUrl() {
        return this.GetHostUrl() + "/api";
    }

    /**
     * 设置用户API访问地址
     */
    public static GetHostUrl() {
        // return "http://192.168.43.34:1002";
        // return "http://192.168.43.34:1002";
        // return "http://dfgapi.dafugui222.com";
        return "";

    }

    public GetHostURL() {
        return '';
    }

    public static GetSignalrServerUrl() {
        // return "/signalr";
        return "http://websockettest.roostyle.com";
    }

    /**
     * 设置标题
     * 2017-02-15
     * @param {string} newTitle 
     * @memberof AppConfig
     */
    public setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }

    /**
     * 封单提示音
     * TQQ 2017-02-25
     * @memberof AppConfig
     */
    public createMp3() {
        !this.mp3.paused && (this.mp3.pause(), this.mp3.currentTime = 0);
        this.mp3.play();
    }

    /**
     * TQQ 2017-02-25
     * 开奖号码提示
     * @param opennum 开奖号码
     */
    public createNumMp3(opennum: string) {
        let url = "assets/mp3/sound/";
        let mp3 = new Audio(url + "open2.wav");
        mp3.play();
        mp3.remove();
        // let nums = opennum.split(",");
        // let i = 0;
        // let intervalId = setTimeout(s => {
        //     let id = setInterval(() => {
        //         mp3 = new Audio(url + "m_" + parseInt(nums[i]) + ".wav");
        //         mp3.play();
        //         // mp3.remove();
        //         i++;
        //         if (i == nums.length) {
        //             clearInterval(id);
        //         }
        //     }, 600);
        //     clearTimeout(intervalId);
        // }, 1800);
    }
}




// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/app.config.ts